import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
//import deburr from 'lodash/deburr';
import Autosuggest from 'react-autosuggest';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import AbEnvironment from '../auth/AbEnvironment';
import AppFetch from './AppFetch';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Button, FormControl, FormControlLabel, FormGroup, Grid,
         MenuItem, Paper, Select,
         Switch, TextField, Typography
} from '@mui/material';

//import Search from '@mui/icons-material/Search';

import AppCreateMutation from './AppCreateMutation';
import AccountFetch from '../account/AccountFetch';
import PageTitle from '../ui/PageTitle';
import SavingSpinner from '../ui/SavingSpinner'
import CurrencyTextField from '../ui/CurrencyTextField';
import AppBindStyles from '../../AppBindStyles';
import AppLogo from '../ui/AppLogo';


const abEnvironment = new AbEnvironment();

function renderInputComponent(inputProps) {
  const { classes, inputRef = () => {}, ref, ...other } = inputProps;

  return (
    <TextField
      fullWidth
      InputProps={{
        inputRef: node => {
          ref(node);
          inputRef(node);
        },
        classes: {
          input: classes.input,
        },
      }}
      {...other}
    />
  );
}

function renderSuggestion(suggestion, { query, isHighlighted }) {
  const matches = match(suggestion.appName, query);
  const parts = parse(suggestion.appName, matches);

  // Is this template app or a vendor app?
  let accountId = abEnvironment.getUserAttribute('a_id');
  let isTemplate = false;
  let actionText = "Add service catalog entry";
  if (suggestion.accountId === accountId) {
    if (suggestion.appId == null) {
      actionText = "Add service catalog entry";
    } else {
      isTemplate = true;
      actionText = "Copy existing service catalog entry";
    }
  }

  // Setup the suggestion.  We now suggest all apps, so
  // each sku is shown as a distinct app.
  let skuPart = '';
  let modelPart = '';
  if (isTemplate) {
    if (suggestion.appSku != null && suggestion.appSku != '' && suggestion.appSku != suggestion.appName) {
      skuPart = ' ' + suggestion.appSku;
    }

    let formattedPrice = Number(suggestion.appSkuPrice)
                    .toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
    if (suggestion.billingFrequency === 0) {
      modelPart = "One-time fee (amount " + formattedPrice + ")";
     
    } else if (suggestion.billingFrequency === 1) {
      modelPart = "Monthly (amount " + formattedPrice + ")";
    } else if (suggestion.billingFrequency === 2) {
      modelPart = "Annual (amount " + formattedPrice + ")";
    }
  } else {
    if (suggestion.appSku != null && suggestion.appSku != '' && suggestion.appSku != suggestion.appName) {
      skuPart = ' ' + suggestion.appSku;
    }
  }

  return (
    <MenuItem selected={isHighlighted} component="div" className="suggestionContainer">
      <Grid container spacing={1} direction="row" justifyContent="flex-start">
        <Grid item xs={2} sm={1} md={1}>
          <AppLogo logoPath={suggestion.appLogo} appName={suggestion.appName} imageHeight='24px'/>
        </Grid>
        <Grid item xs={10} sm={11} md={3}>
          <Typography variant="subtitle1">
          {parts.map((part, index) => {
            if (part.highlight && suggestion.appLogo != null) {
              return (<strong key={index}>{part.text}</strong>);
            } else {
              return (part.text);
            }
          })}
          {skuPart}
          </Typography>
        </Grid>
        <Grid item xs={10} sm={11} md={5} className="asku">
          <Typography variant="subtitle1">
            {modelPart}
          </Typography>
        </Grid>
        <Grid item xs={10} sm={11} md={3} className="actionText">
          <Typography variant="subtitle1">
            {actionText}
          </Typography>
        </Grid>
      </Grid>
    </MenuItem>
  );
}

const getSuggestionValue = suggestion => suggestion.appName;

//these two needed to make warnings go away in autoselect.  Should not be the case according to doc.
function getSectionSuggestions(section) {
  return null;
}

function renderSectionTitle(section) {
  return null;
}

const styleSheet = theme => ({
    root: {
      flexGrow: 1,
    },
    flex: {
      flex: 1,
    },
    container: {
      position: 'relative',
    },
    '@global': {
      /* 960px or less */
      [theme.breakpoints.down( 'md' )]: {
        'div.suggestionContainer': {
          height: 24 * 4,
        },
        'div.asku': {
          marginLeft: '8.33%',
        },
        'div.actionText': {
          marginLeft: '8.33%',
        }
      },
      /* 600px or less */
      [theme.breakpoints.down( 'sm' )]: {
        'div.suggestionContainer': {
          height: 24 * 4,
        },
        'div.asku': {
          marginLeft: '16.66%',
        },
        'div.actionText': {
          marginLeft: '16.66%',
        }
      },
    },
    suggestionsContainerOpen: {
      position: 'absolute',
      zIndex: 1,
      marginTop: theme.spacing(1),
      left: 0,
      right: 0,
    },
    suggestion: {
      display: 'block',
    },
    suggestionsList: {
      margin: 0,
      padding: 0,
      listStyleType: 'none',
    },
    divider: {
      height: theme.spacing(2),
    },
    paper: {
      marginTop: 16,
      padding: theme.spacing(3),
      textAlign: 'left',
      color: theme.palette.text.secondary,
      maxWidth: 980
    },
    currencyField: {
      width: 120,
      marginTop: 4,
      marginBottom: 4
    },
    frequency: {
      width: 120,
      marginTop: 4,
      marginBottom: 4
    }
});

class ServiceCreate extends Component {

  constructor(props) {
    super(props);

    this.state = {
      suggestions: [],
      showSpinner: false,
      searchP: '',
      editDisabled: true,
      urlDisabled: true,
      value: 0,
      selectedApp: null,
      appId: null,
      accountId: abEnvironment.getUserAttribute('a_id'),
      appStatus: 0,
      appName: '',
      appSku: '',
      appUrl: '',
      signupUrl: '',
      appLogo: null,
      description: '',
      appType: 1,
      parentAppId: null,
      oemAppId: null,
      atId: 'f5c70f86-135a-11e8-bb45-97ef56920c02',
      appSkuPrice: 0.00,
      appMarkupAbsolute: 0.00,
      appMarkupPercentage: (abEnvironment.getUserAttribute('a_aType') === "1")  ? 10.0 : 0,  //vendor default markup to 10%,
      jitFloatDefault: 0,
      marqetaMid: null,
      marqetaMname: null,
      maxCharge: 1000.00,
      paymentOrder: 0, 
      passThroughFees: 0,
      wholesaleDiscountPercentage: 0,
      file: null,
      accountLogo: null,
      billingFrequency: 0,
    }
  }

  componentDidMount() {
    //if user is a vendor, fetch account and see if there is a logo on it to use as default.
    if (this.props.auth.isAuthenticatedVendor()) {
      this.fetchAccount();
    }
  }

  /* See if there is an account logo */
  fetchAccount = () => {
    let accountId = abEnvironment.getUserAttribute('a_id');
    AccountFetch.fetch(accountId).toPromise()
    .then(af => {
       if (af.accountTByAccountId) {
         this.setState({accountLogo: af.accountTByAccountId.logo});
       }
    })
    .catch(err => {
      //nothing to do....
    })
  }


  getValueForRender(state_member, prop_member, theDefault)
  {
    if (state_member != null)
      return state_member;

    if (prop_member != null)
    {
      state_member = prop_member;
      return prop_member;
    }

    return theDefault;
  }

  getValueForBillingFrequencyRender() {
      
    if (this.state.billingFrequency != null) {
      return this.state.billingFrequency;
    }

    return 0;
  }


  setStateFromSelection(anode)
  {
    let appName = anode.appName;
    if (appName.length > 64) {
      appName = appName.substring(0, 64)
    }

    let disableUrl = true;
    if (anode.appUrl.length === 0)
      disableUrl = false;

    let amPerc = 0.00;
    if (anode.appMarkupPercentage) {
      amPerc = anode.appMarkupPercentage;
    }

    let wdPerc = 0.00;
    if (anode.wholesaleDiscountPercentage) {
      wdPerc = anode.wholesaleDiscountPercentage;
    }

    let appSkuPrice = 0.00;
    if (anode.appSkuPrice) {
      appSkuPrice = anode.appSkuPrice;
    }

    let billingFrequency = 0;
    if (anode.billingFrequency) {
      billingFrequency = anode.billingFrequency
    }


    let oemAppId = null;
    if (this.props.auth.isAuthenticatedReseller()) {
      let accountId = abEnvironment.getUserAttribute('a_id');
      if (anode.accountId === accountId) {
        //I am a reseller and I am making a copy of an app I "own"
        if (anode.oemAppId) {
          //if the app has an oem app id, it means this app was copied from a vendor app, keep it.
          oemAppId = anode.oemAppId;
        }
      } else {
        //I am a reseller and I am making a copy of app that is not my account, set oem app id to vendor
        oemAppId = anode.appId;
      }
    }

    var newStateVals = {
        // selectedSku: skuidx,
        searchP: appName,
        urlDisabled: disableUrl,
        editDisabled: false,
        selectedApp: anode,
        appName: appName,
        appUrl: anode.appUrl,
        signupUrl: (anode.signupUrl ? anode.signupUrl : ''),
        appLogo: anode.appLogo,
        appSku: anode.appSku,
        oemAppId: oemAppId,
        description: anode.description,
        marqetaMid: anode.marqetaMid,
        marqetaMname: anode.marqetaMname,
        maxCharge: anode.maxCharge,
        paymentOrder: anode.paymentOrder,
        appMarkupPercentage: amPerc,
        passThroughFees: anode.passThroughFees,
        wholesaleDiscountPercentage: wdPerc,
        billingFrequency: billingFrequency,
        appSkuPrice: appSkuPrice
    }

    this.setState(newStateVals);
  }

  goBack() {
    this.props.history.goBack();
  }

  handleChange = name => event => {
    if (name === 'searchP')
    {
      let newStateVals = {
        searchP: event.target.value
      };
      this.setState(newStateVals);
    }
    else
    {
      this.setState({
        [name]: event.target.value,
      });
    }
  };

  showSpinner() {
    return this.state.showSpinner;
  }

  _createService = () => {
    this.setState({ showSpinner: true });
    const { accountId, appStatus, appName, appSku, appUrl, signupUrl, appLogo,
            description, appType, parentAppId, oemAppId, atId,
            appSkuPrice, appMarkupAbsolute, appMarkupPercentage, jitFloatDefault,
            marqetaMid, marqetaMname, maxCharge, paymentOrder, passThroughFees, wholesaleDiscountPercentage, billingFrequency } = this.state;

    let logo = appLogo;
    if (!logo && this.props.auth.isAuthenticatedVendor()) {
      logo = this.state.accountLogo;
    }
    AppCreateMutation.commit(accountId, appStatus, appName,
                             appSku, appUrl, signupUrl, logo, description, appType,
                             parentAppId, oemAppId, atId,
                             appSkuPrice, appMarkupAbsolute, appMarkupPercentage, jitFloatDefault,
                             marqetaMid, marqetaMname, maxCharge, paymentOrder, passThroughFees, wholesaleDiscountPercentage, billingFrequency)
    .then(response => {
      this.setState({ showSpinner: false });
      this.goBack();
    })
    .catch(error => {
      this.setState({ showSpinner: false });
      this.goBack();
    });
  }

  disableServiceSave() {
    if (this.areFieldsInError()) {
      return true;
    }            

    return false;
  }
  
  disableForInvalidDomainName(stateVar) {

    if (stateVar !== null && stateVar !== '') {
         //Validate against reg ex domain check  (used this pattern: https://regexr.com/3au3g)
        var re = new RegExp(/(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/); 
        return !re.test(stateVar);
    } else {
      return false;
    }

  }

  submitFile = event => {
    event.preventDefault();

    const { callPartnerApi, logError } = this.props.auth;
    let theFile = this.state.file[0];
    let theFilename = theFile.name;
    let theFiletype = theFile.type;
    const formData = new FormData();
    formData.append('fname', theFilename);
    formData.append('ftype', theFiletype);
    formData.append('file', theFile);
    callPartnerApi('appbind/logo',
                   'POST',
                   formData,
                   false,
                   'multipart/form-data')
    .then(response => {
      // TODO
/*
      return response.text();
    })
    .then(theText => {
*/
    })
    .catch(error => {
      logError('Exception in ServiceCreate.js: ' + error);
    });
  }

  handleFileUpload = event => {
    this.setState({file: event.target.files});
  }

  onSuggestionsFetchRequested = ({ value }) => {
    this.fetchApps(value);
  }

  onSuggestionsClearRequested = () => {
    this.setState({suggestions: []});
  }

  onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) =>{
    // alert(suggestionValue);
    this.setStateFromSelection(suggestion);
  }

  /*
   * Lookup available apps by app name
   */
  fetchApps = (searchParm) => {
    //let parentId = abEnvironment.getUserAttribute('a_parentId');
    let accountId = abEnvironment.getUserAttribute('a_id');

    AppFetch.fetch(accountId, searchParm, 1, 50).toPromise()
    .then(af => {
      const thenodes = af.appsearchallavailablebyappname2.nodes;

      //
      // Show each individual template app and vendor app
      //
      // Previously, vendor apps were consolidated (if there were
      // multiple skus of the same app, they were shown as one
      // entry).  Now we're showing each distinct entry, so there
      // is no difference in behavior between vendor apps and template
      // apps.
      //
      let theApps = [];
      let adx = 0;
      for (let i=0; i<thenodes.length; i++)
      {
        let n = thenodes[i];

        var anApp = {
          appIdx: adx,
          accountId: n.accountId,
          appName: n.appName,
          appUrl: n.appUrl,
          signupUrl: n.signupUrl,
          appLogo: n.appLogo,
          appMarkupPercentage: n.appMarkupPercentage,
          appId: n.appId,
          appSku: n.appSku,
          oemAppId: n.oemAppId,
          description: n.description,
          marqetaMid: n.marqetaMid,
          paymentOrder: n.paymentOrder,
          passThroughFees: n.passThroughFees,
          wholesaleDiscountPercentage: n.wholesaleDiscountPercentage,
          billingFrequency: n.billingFrequency,
          appSkuPrice: n.appSkuPrice
        };
        theApps.push(anApp);
        adx++;

        if (adx >= 10)
          break;
      };

      if (adx === 0)
      {
        // Custom App Entry
        var custApp = {
          appIdx: adx,
          accountId: abEnvironment.getUserAttribute('a_id'),
          appName: searchParm,
          appUrl: '',
          signupUrl: '',
          appLogo: this.getCustomAppLogo(),
          appMarkupPercentage: 0.00,
          appId: null,
          appSku: '',
          description: searchParm,
          marqetaMid: null,
          paymentOrder: 0,
          passThroughFees: 0,
          wholesaleDiscountPercentage: 0.00,
          appSkuPrice: 0.00
        };
        theApps.push(custApp);
      }
      this.setState({suggestions: theApps});
    })
    .catch(err => {
      this.setState({suggestions: []});
    })
  }

  getCustomAppLogo() {
    if (this.props.auth.isAuthenticatedVendor()) {
      //if a vendor and they have a logo set, use it to default drop down
      if (this.state.accountLogo !== null) {
        return this.state.accountLogo;
      } else {
        return null;
      }
    } else {
      return null;
    }  
  }

  getErrorMessage(field, minValue, maxValue) {
    let errMesg = null;

    let value = Number(field); 
    if (value < minValue) {
      return 'Cannot be less than ' + minValue;
    }
    if (value > maxValue) {
      return 'Cannot be greater than ' + maxValue;
    }

    return errMesg;
  }

  areFieldsInError() {
    const { getMaxServiceAmount } = this.props.auth;
      
    if (this.state.appSkuPrice !== null && this.getErrorMessage(this.state.appSkuPrice, 1, getMaxServiceAmount()) !== null) {
      return true;
    }
    return false;
  }


  render() {
    const { isAuthenticated, isAuthenticatedReseller, needAssent, getMaxServiceAmount } = this.props.auth;
    const classes = this.props.classes;
    // const { anchorEl } = this.state;

 
    if (!isAuthenticated() || needAssent()) {
      return (
        <Redirect to='/home' />
      );
    } else if (isAuthenticatedReseller()) {
      return (
        <Grid container spacing={3} direction="row" justifyContent="flex-start">
          <Grid item xs={12}>
            <PageTitle title="Add service" showBackButton={true} name="service catalog" noMargin={true} history={this.props.history}/>
          </Grid>
          <Grid item xs={12}>
            <Paper className={classes.paper}>
              <Autosuggest
                renderInputComponent={renderInputComponent}
                suggestions={this.state.suggestions}
                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                onSuggestionSelected={this.onSuggestionSelected}
                getSuggestionValue={getSuggestionValue}
                renderSuggestion={renderSuggestion}
                multiSection={false}
                renderSectionTitle={renderSectionTitle}
                getSectionSuggestions={getSectionSuggestions}
                inputProps={{
                  classes,
                  placeholder: "Type a service name here",
                  value: this.state.searchP,
                  onChange: this.handleChange('searchP')
                }}
                theme={{
                  container: classes.container,
                  suggestionsContainerOpen: classes.suggestionsContainerOpen,
                  suggestionsList: classes.suggestionsList,
                  suggestion: classes.suggestion,
                }}
                renderSuggestionsContainer={options => (
                  <Paper {...options.containerProps} square>
                    {options.children}
                  </Paper>
                )}
              />
              <Grid container spacing={2} direction="row" justifyContent="space-between" style={{marginTop: 16}} >            
                <Grid item xs={12} md={6} >
                  <TextField
                    id="app-name" label="Service name" 
                    value={this.state.appName}
                    disabled={this.state.editDisabled}
                    onChange={(e) => this.setState({ appName: e.target.value })}
                    inputProps={{ maxLength: 64 }}
                  />
                </Grid>

                { (false && ! this.state.urlDisabled) &&
                  <Grid item xs={12}>
                    <form onSubmit={this.submitFile}>
                      <input label='upload file' type='file' onChange={this.handleFileUpload}/>
                      <button type='submit'>Upload</button>
                    </form>
                  </Grid>
                }
                <Grid item xs={12}>
                  <TextField
                    id="description" label="Description"
                    value={this.state.description}
                    fullWidth
                    multiline
                    disabled={this.state.editDisabled}
                    onChange={(e) => this.setState({ description: e.target.value })}
                    inputProps={{ maxLength: 2048 }} />
                </Grid>
                <Grid item xs={12}>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={this.getValueForRender(this.state.appStatus === 0)}
                          disabled={this.state.editDisabled}
                          onChange={(e, checked) => {
                            if (checked) {
                              this.setState({ appStatus: 0});
                            } else {
                              this.setState({ appStatus: 1});
                            }
                          }}
                        />
                      }
                      label="Active"
                    />
                  </FormGroup>
                </Grid>
              </Grid>

              <Grid container spacing={1} direction="row" justifyContent="space-between">      
                {isAuthenticatedReseller() && !this.state.editDisabled && (
                  <React.Fragment>

                    <Grid item xs={12}>
                      <Grid container spacing={0} direction="row" justifyContent="flex-start">
                        <Grid item xs={12}>
                          <Typography variant="h6" style={AppBindStyles.sectionTitle}>Manage terms</Typography>
                        </Grid>                          
                        <Grid item xs={12}>
                          <Typography variant="body2">Manage the default billing terms for {this.state.appName}</Typography>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item xs={12}>
                      <Grid container justifyContent="space-between" alignItems="center" spacing={0}>
                        <Grid item>
                          <Grid container direction="column" spacing={0}>
                            <Grid item>
                              <Typography variant="body1" style={AppBindStyles.boldLabel}>{"Amount"}</Typography>
                            </Grid>
                            <Grid item style={AppBindStyles.markupDescription}> 
                              <Typography variant="caption">{'This amount will be billed '}</Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item > 
                          <CurrencyTextField id="appSkuPrice" className={classes.currencyField}
                            value={this.state.appSkuPrice}
                            showErrMsg={true}
                            allowNegative={false}
                            minValue={1}
                            maxValue={getMaxServiceAmount()}
                            minEnterValue={0}
                            maxEnterValue={99999999}
                            onChange={(e) => this.setState({ appSkuPrice: (e.target.value) ? e.target.value : '0' })}
                            textAlign="right"
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    
                    <Grid item xs={12}>
                      <Grid container spacing={1} justifyContent="space-between">
                        <Grid item>
                          <Grid container direction="column" spacing={0}>
                            <Grid item>
                              <Typography variant="body1" style={AppBindStyles.boldLabel}>{"Frequency"}</Typography>
                            </Grid>
                            <Grid item style={AppBindStyles.markupDescription}> 
                              <Typography variant="caption" >Monthly occurs on customer's billing day of month</Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item > 
                          <FormControl>
                            <Select
                              className={classes.frequency}
                              value={this.getValueForBillingFrequencyRender()}
                              disabled={this.state.editDisabled}
                              onChange={(e) => { 
                                  this.setState({ billingFrequency: e.target.value }); 
                              } }
                              inputProps={{
                                name: 'billingFrequency',
                                id: 'billingFrequency',
                              }}
                            >                                   
                              <MenuItem value={0}>One-time fee</MenuItem>
                              <MenuItem value={1}>Monthly</MenuItem>
                              {/*<MenuItem value={2}>Annual</MenuItem>*/}
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </Grid>
                  </React.Fragment>
                )}
                <Grid item xs={12}>
                  { !this.showSpinner() && this.state.appName &&
                    <Button variant="contained" color="primary" disabled={this.disableServiceSave()} style={AppBindStyles.bottomButton} onClick={() => {this._createService()}}>
                      Save
                    </Button>
                  }
                  { !this.showSpinner() && !this.state.appName &&
                    <Button variant="contained" color="primary" disabled style={AppBindStyles.bottomButton}>
                      Save
                    </Button>
                  }
                  {this.showSpinner() &&
                  <Button color="primary" variant="contained" >
                    <SavingSpinner/></Button>
                  }
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      );
    }
    else
    {
      return (
        <Redirect to='/home' />
      );
    }
  }
}

ServiceCreate.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(ServiceCreate);
